import { useAppSelector } from 'store/hooks'
import { useWidgetPreview } from '../context/WidgetPreviewContext'
import { DAILY_STATISTICS_MOCK } from '../mocks/dailyStatisticsMock'

export const useWidgetDailyStatistics = () => {
	const { isPreview } = useWidgetPreview()
	const { dailyStatistics, loadingStatistics, error } = useAppSelector(
		state => state.cattlesSlice,
	)

	if (isPreview) {
		return {
			dailyStatistics: DAILY_STATISTICS_MOCK,
			loadingStatistics: false,
			error: undefined,
		}
	}

	return {
		dailyStatistics,
		loadingStatistics,
		error,
	}
}
